'use client';

import { Component, type ErrorInfo, type ReactNode } from 'react';
import { RushMidErrorScreen } from './RushMidErrorScreen';

interface Props { children: ReactNode }
interface State { error: Error | null }

export class RushMidErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('[rush-mid] crashed:', error, info.componentStack);
    void import('@datadog/browser-rum')
      .then(({ datadogRum }) => datadogRum.addError(error, { feature: 'rush-mid', componentStack: info.componentStack }))
      .catch(() => { });
  }

  render(): ReactNode {
    const { error } = this.state;
    if (error) {
      const detail = [error.message || 'Unknown error', error.stack?.split('\n')[1]?.trim()].filter(Boolean).join('\n');
      return <RushMidErrorScreen message={detail} onBack={() => this.setState({ error: null })} />;
    }
    return this.props.children;
  }
}
